import Axios, { AxiosInstance } from 'axios'
import { DynamicPricingRequest } from '../interfaces/DynamicPricingRequest.interface'
import { DynamicPricingInterface } from '../interfaces/DynamicPricing.interface'
import { DayPricingInterface } from '../interfaces/DayPricing.interface'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'

interface DynamicPricingServiceInterface {
  postDynamicPricingByProductAttributes(productAttributeInfo: DynamicPricingRequest): Promise<DynamicPricingInterface>
}

class DynamicPricingService implements DynamicPricingServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
    })
  }

  async postDynamicPricingByProductAttributes(pricingRequest: DynamicPricingRequest): Promise<DynamicPricingInterface> {
    const dynamicPricingResponse = await this.axios.post(
      this.config.postDynamicPricingByProductAttributes,
      pricingRequest
    )
    return this.convertResponse(dynamicPricingResponse.data)
  }

  convertResponse(data: any): DynamicPricingInterface {
    let dayPricingList = []
    // Clean up the pricing data if dynamic pricing exists
    if (data.Variants && data.Variants.length && data.Variants[0].DayPriceList) {
      // With the way our API works, there will only ever be one variant returned if it exists
      dayPricingList = data.Variants[0].DayPriceLists.map((dayPricing): DayPricingInterface => {
        return {
          date: dayPricing.Date,
          basePrice: dayPricing.BasePrice,
          price: dayPricing.Price,
          tierPrice: dayPricing.InventoryPriceListLevelPrice,
          tierNumberRemaining: dayPricing.InventoryPriceListLevelNumberRemaining,
        }
      })
    }
    return {
      inventoryThreshold: data.inventoryThreshold || 0,
      inventoryCounts: data.inventory ? data.inventory.InventoryCounts : {},
      dayPricing: dayPricingList,
    }
  }
}

const dynamicPricingService = new DynamicPricingService(apiConstants)
export { dynamicPricingService }
